/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: telephonyServers.types.ts
 🗓️ Created: 2025-01-XX
 🧩 Description:
    TypeScript type definitions for the Telephony Servers frontend module.
────────────────────────────────────────────────────────────────*/

export interface TelephonyServer {
  id: number;
  uuid: string;
  name: string;
  description?: string | null;
  host: string;
  port: number;
  username: string;
  eslHost: string;
  freeswitchPort: number;
  timezone?: string | null;
  location?: string | null;
  monitoringEnabled: boolean;
  healthCheckInterval: number;
  status: 'online' | 'offline' | 'error' | 'unknown';
  freeswitchStatus: 'online' | 'offline' | 'error' | 'unknown';
  lastSeen?: string | null;
  lastError?: string | null;
  version?: string | null;
  sshKeyGenerated: boolean;
  sshKeyFingerprint?: string | null;
  useVpn?: boolean;
  bindInterface?: string;
  vpnIp?: string | null;
  isLocal: boolean;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface ListTelephonyServersResponse {
  success: boolean;
  data: TelephonyServer[];
  pagination?: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
}

export interface TelephonyServerFormData {
  id?: string | number;
  name: string;
  description?: string;
  host: string;
  port: number;
  username: string;
  password?: string;
  eslHost: string;
  freeswitchPort: number;
  freeswitchPassword?: string;
  timezone?: string;
  location?: string;
  monitoringEnabled: boolean;
  healthCheckInterval: number;
  useVpn?: boolean;
  bindInterface?: string;
  vpnIp?: string;
  isActive?: boolean;
}

export interface FetchTelephonyServersParams {
  page: number;
  limit: number;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
  search?: string;
}

export const STATUS_STYLES: Record<string, { badge: string; text: string }> = {
  online: { badge: 'bg-green-100 text-green-800', text: 'telephonyServers.status.online' },
  offline: { badge: 'bg-red-100 text-red-800', text: 'telephonyServers.status.offline' },
  error: { badge: 'bg-yellow-100 text-yellow-800', text: 'telephonyServers.status.error' },
  unknown: { badge: 'bg-slate-100 text-slate-800', text: 'telephonyServers.status.unknown' },
};

